import React, { useState, useEffect, useRef } from 'react';
import { Badge, Button, Col, Form, InputGroup, Row, Table, Modal, ModalTitle } from 'react-bootstrap';
import { Link } from 'react-router-dom';   

import { MultiSelect } from 'react-multi-select-component';
import Dropdown from 'react-bootstrap/Dropdown';
import Trash from '../../../assets/images/trash.png'; 
import Autosuggest from 'react-autosuggest';
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faEllipsis, faTrashCan, faPencil, faEnvelope, faArrowLeft, faChevronDown, faChevronUp, faCircleXmark, faPlus, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { STATIONGRID, TRUCKERADDEMAIL, TRUCKEREDITEMAIL, TRUCKERDELEMAIL, TRUCKERSAVERATE, TRUCKERRATELIST, GETDESTINATION } from '../../../Utils/conts.js';
import ImageUpload from '../../../Components/common/ImageUpload.js';

// const getLocalEmail = () => {
//     const lists = localStorage.getItem("truckerEmail"); 

//     if (lists) {
//       return JSON.parse(lists);
//     } else {
//       return [];
//     }
//   };

const TruckerDetails = ({ rowData, stationID, reload, onEdit, dload }) => {

    const [boardPoint, setBoardpoint] = useState([]);
    const isMounted = useRef(false);
    const truckerParent = rowData?.args.row.bounddata;
    console.log("🚀 ~ TruckerDetails ~ truckerParent:", truckerParent)
    const [disLoading, setDisLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const emailArray = JSON.parse(truckerParent.pickup_emails);
    const [emailShow, setEmailShow] = useState(false);
    const inputEmailShow = () => setEmailShow(true);
    const [inputData, setInputData] = useState("");
    const [items, setItems] = useState(emailArray);
    const [editEmail, setEditEmail] = useState('');
    const [toggleButton, setToggleButton] = useState(false);
    const [showManage, setShowManage] = useState('');

    const AddEmail = async () => {
        if (inputData == '') {
            // Alert('Please input Email');
            console.log("Please input Email");
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
        }
        else if (inputData && toggleButton) {
            // if (index){
            const NewItemData = {
                // id: new Date().getTime().toString(),
                id: truckerParent.id,
                email: inputData,
                email_key: editEmail,
            }
            // }
            try {
                const res = await withRFSToken.post('rfs-setting/save-pickup-email', NewItemData)
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setItems(innerData);
                        reload();
                        // loadDetails(truckerParent.trucker_id);
                        // setExportGrid(innerData.export);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
            // setItems(items.map((elem) => {
            //     if(elem.id === editEmail){
            //         return {...elem, name: inputData}
            //     }
            //     return elem;
            // }));
            setInputData('');
            setEditEmail(null);
            setToggleButton(false);
            setEmailShow(false);
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validateEmail = (email) => {
                return emailRegex.test(email);
            };
            if (!validateEmail(inputData)) {
                toast.error('Invalid email address');
                setEmailShow(true);
            } else {
                const NewItemData = {
                    // id: new Date().getTime().toString(),
                    id: truckerParent.id,
                    email: inputData
                }
                try {
                    const res = await withRFSToken.post('rfs-setting/save-pickup-email', NewItemData)
                        .then(function (res) {
                            const innerData = res.data.response_data;
                            setItems(innerData);
                            // setExportGrid(innerData.export);
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
                // setItems([...items, NewItemData]);
                setEmailShow(false);
            }

            // localStorage.setItem('TruckerEmail', JSON.stringify(NewItemData));
        }
        setInputData('');
        // setEmailShow(false);

    }
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const deleteEmail = async (index) => {
        try {
            const res = await withRFSToken.post('rfs-setting/pickup-email-delete', { id: truckerParent.id, email_key: index })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setItems(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // setItems(updatedItem);
    }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    const loadDetails = async (uldNumber) => {
        setDisLoading(true);
        try {
            const res = await withRFSToken.post('trucker-details', { trucker_id: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSelectedRowData(innerData);
                    setDisLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setDisLoading(false);
        }
    }
    return (
        <>
            {/* {console.log('formData', formData)} */}
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {showManage === '' &&
                <Row className='mt-3'>
                    <Col lg="5" className='pt-4  brd_rgt' >
                        <div className='d-flex justify-content-between'>
                            <div>
                                <h4>Trucker Details</h4>
                                <p>Add truckers and manage truckers.</p>
                            </div>
                        </div>
                        <div className='truck_info'>
                            <div className='d-flex justify-content-between'>
                                <h6>Trucker Information</h6>
                                {/* <Button variant="link" onClick={() => handleEditClick('at')}><FontAwesomeIcon icon={faPencil} /> Edit</Button> */}
                            </div>

                            <ul>
                                <li>Trucker Name : <span>{truckerParent?.org_name}</span></li>
                                <li>Trucker Email : <span>{truckerParent?.email}</span></li>
                                <li>Phone No. :<span>{truckerParent?.phone}</span></li>
                            </ul>
                        </div>
                        <div className='d-flex justify-content-between py-2'>
                            <h6>Ready for Pickup - Email Address</h6>
                            <div className='align-self-center'>
                                <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                            </div>
                        </div>
                        <div className='addresses'>
                            {emailShow &&
                                <>
                                    <div className='add_email'>
                                        <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                        {toggleButton ? <button onClick={AddEmail}>Edit</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                    </div>
                                </>
                            }
                            <div className='showItem'>
                                {items && items.map((elem, index) => {
                                    return (
                                        <div className='eachItem' key={index}>
                                            <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                            {/* <button>Edit</button> */}
                                            <div className='request_email'>
                                                <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                            </div>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            {/* <ImageUpload
                                attachable_type={"trucker"} 
                                attachable_id={truckerParent?.id}
                                attachments={truckerParent?.attachments}
                                onDeleteSuccess={() => loadDetails(truckerParent?.id)}
                            /> */}
                        </div>
                    </Col>
                </Row >
            }
        </>
    )
}

export default TruckerDetails;